export default function(x) {
  var r = Math.exp(x);
  r = (r - 1 / r) / 2;
  return r;
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/sinh.js
// module id = 80
// module chunks = 0 1